export enum loaderColors {
  WHITE = 'white',
  GRAY = 'gray',
  RED = 'red'
}
